
import { defineComponent } from "vue";
import { Button, Icon, IconButton, ModalWindow } from "@/shared/ui";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";

export default defineComponent({
	name: "ManageMana",
	components: {
		Button,
		IconButton,
		Icon,
		ModalWindow,
	},
	setup() {
		const store = useCharactersStore();

		const { characters, current, maxMana } = storeToRefs(store);
		const { updateName, updateRace, updateLuck } = store;

		return {
			characters,
			current,
			maxMana,
			updateName,
			updateRace,
			updateLuck,
		};
	},
	data() {
		return {
			modal: false,
			value: 0,
			modifier: 0,
		};
	},
	watch: {
		modal() {
			this.value = 0;
			this.modifier = this.characters[this.current].mana.modifier;
		},
	},
	mounted() {
		this.modifier = this.characters[this.current].mana.modifier;
	},
	methods: {
		heal() {
			this.characters[this.current].mana.current = Math.min(
				this.characters[this.current].mana.current + this.value,
				this.maxMana
			);
			this.close();
		},
		damage() {
			this.characters[this.current].mana.current = Math.max(
				this.characters[this.current].mana.current - this.value,
				0
			);
			this.close();
		},
		changeModifier() {
			this.characters[this.current].mana.modifier = this.modifier;
			this.close();
		},
		close() {
			this.value = 0;
			this.modal = false;
		},
	},
});
